module.exports = __webpack_public_path__ + "img/banner-3.52f82eb9.jpg";